import { useState, useId, type ReactNode } from 'react'

interface CollapsibleSectionProps {
  title: string
  children: ReactNode
  defaultOpen?: boolean
}

export function CollapsibleSection({ title, children, defaultOpen = false }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen)
  const id = useId()
  const contentId = `${id}-content`

  return (
    <div className="collapsible-section">
      <button
        type="button"
        id={id}
        className="collapsible-section__trigger"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen(!open)}
      >
        <span className="collapsible-section__title">{title}</span>
        <svg
          className={`collapsible-section__chevron ${open ? 'collapsible-section__chevron--open' : ''}`}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div
        id={contentId}
        className="collapsible-section__content"
        role="region"
        aria-labelledby={id}
        style={{
          display: 'grid',
          gridTemplateRows: open ? '1fr' : '0fr',
          transition: 'grid-template-rows 200ms ease-out',
        }}
      >
        <div className="collapsible-section__inner">
          {children}
        </div>
      </div>
    </div>
  )
}
